const ComponentsLookup = {
  "default-footer": "DefaultFooter45737034Fc654e6f85ae5fbe0426ba62"
}

export default ComponentsLookup;